import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output
} from '@angular/core';

export type ModalPosition = 'center' | 'left' | 'right';

export interface IModalSettings {
  width?: string;
  position?: ModalPosition;
  allowClickOutsideToClose?: boolean;
  allowEscapeToClose?: boolean;
  hasFooter?: boolean;
  hasHeader?: boolean;
  showCloseButton?: boolean;
  customClass?: string;
}

@Component({
  selector: 'sgt-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  private defaultSettings: IModalSettings = {
    showCloseButton: true,
    allowClickOutsideToClose: true,
    allowEscapeToClose: true,
    hasHeader: true,
    position: 'center',
    hasFooter: true,
    width: '600px',
  };

  @Input() isOpen = false;
  @Input() settings: IModalSettings;

  @Output() closed = new EventEmitter<boolean>();
  @Output() confirmed = new EventEmitter<boolean>();

  @ContentChild('header', { read: ElementRef }) headerContent: ElementRef;

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.isOpen && this.settings?.allowEscapeToClose) {
      this.onClose();
    }
  }

  ngOnInit(): void {
    this.settings = {
      ...this.defaultSettings,
      ...this.settings,
    };
  }

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }

  onClose(): void {
    this.close();
    this.closed.emit(false);
  }

  onConfirm(): void {
    this.confirmed.emit(true);
  }

  get modalPositionClass(): string {
    const positionClass = `modal__container--${this.settings?.position}`;
    return this.settings?.customClass
      ? `${positionClass} ${this.settings.customClass}`
      : positionClass;
  }

  get modalStyles(): { [key: string]: string } {
    return {
      width: this.settings?.width,
    };
  }
}
